// extracted by mini-css-extract-plugin
module.exports = {"headerwell":"biijheader-module--headerwell--3rIwo"};